import { render, staticRenderFns } from "./ColumnItem.vue?vue&type=template&id=f88f40c8&"
import script from "./ColumnItem.vue?vue&type=script&lang=ts&"
export * from "./ColumnItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports